var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasketOpenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 19.7083C9.67293 19.7083 10.0833 19.2979 10.0833 18.7917C10.0833 18.2854 9.67293 17.875 9.16667 17.875C8.66041 17.875 8.25 18.2854 8.25 18.7917C8.25 19.2979 8.66041 19.7083 9.16667 19.7083Z",
    stroke: "#008FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 19.7083C17.0064 19.7083 17.4168 19.2979 17.4168 18.7917C17.4168 18.2854 17.0064 17.875 16.5002 17.875C15.9939 17.875 15.5835 18.2854 15.5835 18.7917C15.5835 19.2979 15.9939 19.7083 16.5002 19.7083Z",
    stroke: "#008FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2915 2.2915H5.0415L7.5165 13.6582C7.60221 14.0785 7.83261 14.4555 8.1676 14.7235C8.50258 14.9915 8.92094 15.1335 9.34984 15.1248H16.4082C16.8371 15.1335 17.2554 14.9915 17.5904 14.7235C17.9254 14.4555 18.1558 14.0785 18.2415 13.6582L19.7082 5.95817H6.50817",
    stroke: "#008FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketOpenIcon);
export default __webpack_public_path__ + "static/media/BasketOpenIcon.a14aa663a75c1ab2bd7eeaa46486c670.svg";
export { ForwardRef as ReactComponent };